export const INIT_FILTER_FORM = 'INIT_FILTER_FORM';
export const SET_FILTER_FORM = 'SET_FILTER_FORM';
export const SET_GOOD_LIST = 'SET_GOOD_LIST';
export const SET_DIALOG_SYNC_CROWD = 'SET_DIALOG_SYNC_CROWD';
export const SET_QQ_CROWD_STATE_LIST = 'SET_QQ_CROWD_STATE_LIST';
export const SET_FETCH_GOOD_STATE = 'SET_FETCH_GOOD_STATE';
export const RESET = 'RESET';

// 页码
export const SET_PRODUCT_LIST_PAGE_SIZE = 'SET_PRODUCT_LIST_PAGE_SIZE';
export const SET_PRODUCT_LIST_PAGE_COUNT = 'SET_PRODUCT_LIST_PAGE_COUNT';
export const SET_PRODUCT_LIST_PAGE_TOTAL = 'SET_PRODUCT_LIST_PAGE_TOTAL';
export const INIT_PRODUCT_LIST_PAGE_INFO = 'INIT_PRODUCT_LIST_PAGE_INFO';
